import React, {useReducer} from 'react'

import {Action, NotificationsContext, State} from './NotificationsContext'

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'add': {
      if (state.some(notification => notification.message === action.payload.message)) {
        return state
      }
      return state.concat(action.payload)
    }
    case 'remove': {
      const notification = action.payload
      const index = state.indexOf(notification)

      if (index > -1) {
        state.splice(index, 1)

        return state.slice()
      }

      return state
    }
  }

  return state
}
const initialState: State = []

const NotificationsProvider: React.FC<React.PropsWithChildren<unknown>> = ({children}) => (
  <NotificationsContext.Provider children={children} value={useReducer(reducer, initialState)} />
)

export default NotificationsProvider
